import React from "react";
import "./InsightMeta.css";
import { renderTextWithNormalDash } from "../../utils/textFormatters";

const InsightMeta = ({ author, date, readTime }) => {
  return (
    <div className="insight-meta d-flex align-items-center justify-content-between flex-wrap mb-4">
      <p className="insight-meta-text mb-0 text-white-50">
        <strong className="">{renderTextWithNormalDash(author)}</strong> • {renderTextWithNormalDash(date)} • {readTime}
      </p>
      <div className="d-flex gap-2 z-3">
        <button className="meta-btn">Share</button>
        <button className="meta-btn">Save</button>
      </div>
    </div>
  );
};

export default InsightMeta;